import { useQuery } from '@tanstack/react-query';

import * as ErrorHandler from 'common/ErrorHandler';
import { createQueryKey } from 'helpers/ReactQueryHelpers';
import { getContentfulLandingPage } from 'services/ContentfulLandingPagesService';

import type { ContentfulLandingPageType, QueryClient, ReactQueryOptions } from 'types';

interface Params {
  type: ContentfulLandingPageType,
  slug: string,
  preview: boolean
}

export const useContentfulLandingPage = (params: Params, options: ReactQueryOptions<any> = {}) => {
  return useQuery({
    queryKey: getKey(params),
    queryFn: () => getContentfulLandingPage(params),
    staleTime: Infinity,
    ...options
  });
};

function getKey(params: Params) {
  const { type, slug, preview } = params;
  return createQueryKey([`${type}-landing-page`, slug, preview]);
}

export async function prefetchContentfulLandingPage(
  queryClient: QueryClient,
  params: Params
) {

  if (!params?.type) {
    ErrorHandler.throwError(new Error(), 'Invalid landing page type');
  }

  try {
    const data = await queryClient.fetchQuery({
      queryKey: getKey(params),
      queryFn: () => getContentfulLandingPage(params)
    });
    return data;
  } catch (err) {
    return false;
  }
}
